import React, { useEffect, useState } from "react";
import axios from "axios";
import { Form, Col, Row, Alert } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import LoadingContent from "../../../components/LoadingContent";
import Title from "../../../components/Admin/Title";
import "../../../assets/style/imgnewsrally_v1.css";
import GeminiRequest from "../../../components/GeminiRequest";
import { processMilestoneAuto } from "../../../utils/Milestones";

const GPGenerator = () => {
  const { t } = useTranslation();
  const [data, setData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const [update, setUpdate] = useState(false);
  const [grandPrixEventId, setGrandPrixEventId] = useState(-1);
  const [customMilestones, setCustomMilestones] = useState<any>(null);
  const [nextGrandsPrix, setNextGrandsPrix] = useState<
    {
      name: string;
      id: number;
      type_race: string;
      type_races: number;
      type_championship: number;
    }[]
  >();

  const [geminiPromptText, setGeminiPromptText] = useState<string>("");

  useEffect(() => {
    axios
      .get(
        `${
          process.env.NODE_ENV === "development"
            ? "http://localhost:5500"
            : "https://ligavirtualf1.es:5500"
        }/api/grandprix/getLastGrandsPrix`,
      )
      .then(({ data }) => {
        setNextGrandsPrix(data.nextGrandsPrix);
        setCustomMilestones(data.milestones);
      })
      .catch(({ response }) => {
        throw new Error(response);
      });
  }, [update]);

  useEffect(() => {
    if (
      grandPrixEventId !== null &&
      grandPrixEventId !== undefined &&
      grandPrixEventId !== -1
    ) {
      setIsLoading(true);
      setData(null);
      setError(null);

      const API_BASE =
        process.env.NODE_ENV === "development"
          ? "http://localhost:5500"
          : "https://ligavirtualf1.es:5500";

      axios
        .get(`${API_BASE}/api/grandprix/getNewsGPGenerateInfo`, {
          params: { grand_prix_event_id: grandPrixEventId },
        })
        .then(({ data }) => {
          setData(data);
          setIsLoading(false);
        })
        .catch((err) => {
          console.error("Error fetching GP info:", err);
          setError("No se pudo cargar la información del Gran Premio.");
          setIsLoading(false);
        });
    }
  }, [grandPrixEventId]);
  useEffect(() => {
    if (data) {
      const gp = nextGrandsPrix?.find((gp) => gp.id === grandPrixEventId);
      // 1. Resumen de la clasificación general de la qualy (qualifyingResults) con Posición de Clase calculada
      const qualyResultsSummary = (() => {
        if (
          !data.qualifyingResults ||
          !data.qualifyingResults.Q3 ||
          data.qualifyingResults.Q3.length === 0
        ) {
          return "No disponible";
        }

        // Objeto para llevar la cuenta de las posiciones por cada clase dinámicamente
        const classCounters: { [key: string]: number } = {};

        return data.qualifyingResults.Q3.map((d: any) => {
          const className = d.class ? "Clase: " + d.class + " |" : "";

          // Incrementamos la posición para esta clase específica
          classCounters[className] = (classCounters[className] || 0) + 1;
          const posClase = classCounters[className];

          const puntos =
            gp?.type_championship !== 4
              ? `| Puntos ${d.points != null ? d.points : 0}`
              : "";
          return `- Pos Clase: ${posClase} | ${className} Piloto: ${d.name} (${d.driver_flag_name}) | Coche: ${d.team} | Gap General: ${d.gap} ${puntos}`;
        }).join("\n");
      })();
      // 2. Resumen de la clasificación general de la carrera (raceResults) con Posición de Clase calculada
      const raceResultsSummary = (() => {
        if (!data.raceResults) {
          return "No disponible";
        }

        const raceKeys = Object.keys(data.raceResults)
          .filter((key) => /^R\d+$/.test(key))
          .sort((a, b) => {
            return parseInt(a.substring(1)) - parseInt(b.substring(1));
          });

        if (raceKeys.length === 0) {
          return "No disponible";
        }

        return raceKeys
          .map((raceKey) => {
            const raceResults = data.raceResults[raceKey];

            if (!raceResults || raceResults.length === 0) {
              return `CARRERA ${raceKey.substring(1)}\nNo disponible`;
            }

            // Contador de posiciones por clase
            const classCounters: { [key: string]: number } = {};

            const raceLines = raceResults.map((positionGroup: any[]) => {
              // positionGroup contiene TODOS los pilotos de esa posición
              // Ejemplo:
              // [
              //   { pos: 2, name: "Jeff", ... },
              //   { pos: 2, name: "Cabezaspeed", ... }
              // ]

              const d = positionGroup[0];

              const className = d.class || "";
              const classKey = className || "SIN_CLASE";

              // Incrementamos posición de esta clase
              classCounters[classKey] = (classCounters[classKey] || 0) + 1;

              const posClase = classCounters[classKey];

              // Todos los pilotos de esta misma posición
              const driversText = positionGroup
                .map((pilot: any) => {
                  return `${pilot.name} (${pilot.driver_flag_name})`;
                })
                .join(" + ");

              const classText = className ? `Clase: ${className} | ` : "";

              return `- Pos Clase: ${posClase} | ${classText}Piloto: ${driversText} | Coche: ${d.team} | Tiempo Total/DNF Reason: ${d.race_time} | Gap General: ${d.gapGral} | Puntos ${d.points}`;
            });

            return `CARRERA ${raceKey.substring(1)}\n${raceLines.join("\n")}`;
          })
          .join("\n\n");
      })();

      // 3. Resumen del campeonato de pilotos (driver_standings)
      const driverStandingsSummary =
        data.driver_standings && data.driver_standings.length > 0
          ? data.driver_standings
              .map(
                (ds: any) =>
                  `- ${ds.position}. ${ds.drivers} - ${ds.points} puntos [Clase: ${ds.class}] -  Balance: ${ds.balance}`,
              )
              .join("\n")
          : "No disponible";

      // 4. Resumen del campeonato de equipos (team_standings)
      const teamStandingsSummary =
        data.team_standings && data.team_standings.length > 0
          ? data.team_standings
              .map(
                (ts: any) =>
                  `- ${ts.position}. ${ts.team_name} - ${ts.points} puntos [Clase: ${ts.class}] -  Balance: ${ts.balance}`,
              )
              .join("\n")
          : "No disponible";
      // 5. Construcción del prompt adaptado para Gemini

      const ronda =
        gp?.type_championship === 4
          ? ""
          : `- Ronda ${data.round_number} de ${data.total_championship_events} del campeonato de ${data.championship}`;
      const promptText = `
  Actúa como un periodista deportivo especializado en motor. Tu objetivo es redactar una crónica de prensa atractiva, profesional y detallada sobre el GP disputado, basándote exclusivamente en los datos proporcionados.
  
  - Nombre Oficial del GP: ${data.name} ${ronda}.
  
  ### Clasificación General Final de la Qualifying (Race Results):
  ${qualyResultsSummary}

  ### Clasificación General Final de la Carrera (Race Results):
  ${raceResultsSummary}
  
  ${
    gp?.type_championship !== 4
      ? `### Clasificación General del Campeonato de Pilotos:
  ${driverStandingsSummary}


  ### Clasificación General del Campeonato de Equipos:
  ${teamStandingsSummary}`
      : ""
  }
  
  
  ### Algunos datos del GP:
${
  customMilestones?.[grandPrixEventId]?.["es"]?.length > 0
    ? customMilestones[grandPrixEventId]["es"]
        .map((milestone: any) => `- ${milestone.description}`)
        .join("\n")
    : ""
}${
        data.milestonesAuto != null && data.milestonesAuto.length > 0
          ? "\n" +
            data.milestonesAuto
              .map(
                (milestone: any) => `- ${processMilestoneAuto(milestone, t)}`,
              )
              .join("\n")
          : ""
      }

  ### Pautas de Redacción:
  - **Titular y Entradilla:** Crea un titular llamativo que resuma lo más destacado de la jornada y una entradilla que mencione el nombre del rally (${data.gp_name}) y los dominadores absolutos de la prueba.
  - **Podio y Resultados Finales:** Utiliza los datos de "Race Results" para detallar quiénes subieron al podio absoluto de la prueba y cuáles fueron las diferencias finales.
  - **Desarrollo por Categorías:** Analiza lo ocurrido en las clases usando los tramos, priorizando la posición por clase y los gaps.
  
  ${
    gp?.type_championship !== 4
      ? `- **Situación del Campeonato:** Dedica un apartado final a repasar cómo quedan las tablas de puntos tanto en el campeonato de pilotos como en el de equipos tras este rally analizando también el balance para saber si han ganado o perdido posiciones con respecto a la ronda anterior, (el balance comentalo para casos muy excepcionales, no lo hagas algo muy relevante). Ten en cuenta que este GP fue la ronda ${data.round_number} de ${data.total_championship_events}.
  Con los Race Results tienes los puntos que consigue cada posición en la carrera (esto se mantiene para las rondas anteriores), con esto, puedes saber por ejemplo si un piloto ya era matemáticamente campeón antes de esta carrera o, si por ejemplo se ha proclamado campeón porque ya no pueden superarle de manera matemática (ya que sabes los puntos que gana el primero). Si no aparece algo referente a que se ha proclamado campeón un piloto en esta cita dentro del apartado de "Algunos datos del GP", no hagas alusión a ello ya eso significa que se ha coronado en algun otro GP, puedes hacer alusión a que ya es campeón, no a que lo haya ganado aquí. 
  - Ten en cuenta que tanto la carrera como la qualy la corremos el mismo día ${data.date} a las ${data.time} CET`
      : ""
  }
   
  Estructura requerida:
  - Título: Máximo 60 caracteres (70 en casos muy extremos).
  - Subtítulo: Alrededor de 100 caracteres, máximo 150.
  - Cuerpo de la noticia: Completo y bien estructurado.
  
Lo necesito formateado con negritas en las partes importantes. Si me pones algun titulo/subtitulo en la noticia, utiliza <h2> en tu respuesta, aunque no en texto plano directamente.
      `.trim();

      setGeminiPromptText(promptText);
    }
  }, [customMilestones, data]);

  if (nextGrandsPrix == null) return <LoadingContent />;

  return (
    <div className="full-height padding-md app-container flex-center-top page-transition noverflow">
      <div className="form-container-md">
        <Title text="GP Generator" />
        <small className="mandatory-fields">(*) Required fields</small>

        <Form>
          <Row className="mb-3">
            <Form.Group className="form-group" as={Col} md="12">
              <Form.Label>Grand Prix (*)</Form.Label>
              <Form.Select
                name="grand_prix"
                required
                onChange={(e) => {
                  setGrandPrixEventId(parseInt(e.target.value));
                }}
              >
                <option value="-1">Select a Grand Prix...</option>
                {nextGrandsPrix.map((gp) => {
                  return (
                    <option key={gp.id} value={gp.id}>
                      {gp.name}
                    </option>
                  );
                })}
              </Form.Select>
            </Form.Group>
          </Row>
        </Form>

        {isLoading && <LoadingContent />}

        {error && (
          <Alert variant="danger" className="mt-2 py-1">
            {error}
          </Alert>
        )}

        {data != null && (
          <div className="mt-4">
            <GeminiRequest text={geminiPromptText} />
          </div>
        )}
      </div>
    </div>
  );
};

export default GPGenerator;
